// Shopping lists are for home cooks. Decided by the account the person is logged into right
// now (its `user_type`), not by whether they also own a business: someone with a farm or
// market can still have a general account and use shopping lists while logged into that one.
export const canUseShopping = (user?: { user_type?: string | null } | null): boolean => {
  const type = user?.user_type?.toLowerCase()
  return type !== 'producer' && type !== 'market'
}
